import { useCurrentModule } from '../components';
import { ECLIPSE_MOBILE_MODULE_NAME } from '../utils/moduleNames';
import { useSwitchFlows } from './useSwitchFlows';
export const AI_RECOMMENDATION_SPEC = 'specs.premium.EclipseDesktopSocialProof';
export const AI_REC_PREMIUM_PLAN_SPEC = 'aiRecPremiumPlan';
export const AI_REC_PREMIUM_PLAN_NON_US_SPEC = 'aiRecPremiumPlanNonUs';
/**
 * Mobile rolls out on its own spec. The desktop specs never apply to mobile
 * and this one never applies to desktop, so either surface can move alone.
 */
export const AI_REC_PREMIUM_PLAN_MOBILE_SPEC = 'aiRecPremiumPlanMobile';
export const useAiRecommendationEnabled = () => {
  const module = useCurrentModule();
  const {
    ready,
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const {
    isSwitchFlow,
    isLoading: isSwitchFlowLoading
  } = useSwitchFlows();
  const isMobile = module.moduleName === ECLIPSE_MOBILE_MODULE_NAME;
  const isLoading = ready === false || isSwitchFlowLoading;
  const isEligible = !isLoading && isSwitchFlow === false;
  if (isMobile) {
    const isSpecOn = ready !== false && experiments.isEnabled(AI_REC_PREMIUM_PLAN_MOBILE_SPEC);
    return {
      isEnabled: isSpecOn && isEligible,
      isLoading: ready === false || isSpecOn && isSwitchFlowLoading,
      isPremiumPlanVariant: false,
      showsGeneratedContent: false
    };
  }
  const isPremiumPlanVariant = isEligible && (experiments.isEnabled(AI_REC_PREMIUM_PLAN_SPEC) || experiments.isEnabled(AI_REC_PREMIUM_PLAN_NON_US_SPEC));
  const isEnabled = isEligible && (experiments.isEnabled(AI_RECOMMENDATION_SPEC) || isPremiumPlanVariant);
  const showsGeneratedContent = isEnabled && !isPremiumPlanVariant;
  return {
    isEnabled,
    isLoading,
    isPremiumPlanVariant,
    showsGeneratedContent
  };
};
//# sourceMappingURL=useAiRecommendationEnabled.js.map